import { Helmet } from 'react-helmet';
import NewdanhmucphieuxuatDetail
  from 'src/components/newdanhmucphieuxuat-detail/NewdanhmucphieuxuatDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmucphieuxuatListToolbar from '../components/newdanhmucphieuxuat-detail/NewdanhmucphieuxuatToolbar';

const Newdanhmucphieuxuat = () => (
  <>
    <Helmet>
      <title>Danh mục phiếu xuất</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmucphieuxuatListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmucphieuxuatDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmucphieuxuat;
